// ─── Moteur i18n (Core) ───────────────────────────────────────────
// Levé de MoPCal : catalogues JSON embarqués + surcharge Firestore (collection
// i18n) fusionnée par-dessus. Résolution : surcharge(langue) → catalogue(langue)
// → catalogue(fr) → clé brute.
import fr from './locales/fr.json';
import en from './locales/en.json';

export const CATALOGUES = { fr, en };
export const LANGUE_DEFAUT = 'fr';
export const LANGUES = [
  { code: 'fr', label: 'Français', drapeau: '🇫🇷', pays: 'fr' },
  { code: 'en', label: 'English',  drapeau: '🇬🇧', pays: 'gb' },
];

function getNested(obj, key) {
  return (key || '').split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
}

export function traduire(key, langue, overrides, params) {
  const ov = overrides && overrides[langue];
  let val = (ov && ov[key] !== undefined) ? ov[key] : undefined;
  if (val === undefined) val = getNested(CATALOGUES[langue], key);
  if (val === undefined) val = getNested(CATALOGUES[LANGUE_DEFAUT], key);
  if (val === undefined) val = key;
  if (params && typeof val === 'string') {
    for (const k of Object.keys(params)) val = val.split('{' + k + '}').join(String(params[k]));
  }
  return val;
}
